// @flow

import { createSelector } from "reselect";
import { curry, view } from "ramda";
import { type State, seletoresAbertosLens } from "../../state";
import {
  type ModoApp,
  type TipoDataBase,
  TIPO_DATA_BASE_AUTOMATICA,
  TIPO_DATA_BASE_FECHAMENTO,
  MODO_APP_SERIES,
} from "../../model";
import { isAxisLens } from "../lenses";

export const isAppIniciada = (state: State): boolean => state.appIniciada;

export const getModoApp = (state: State): ModoApp => state.modoApp;

export const isModoSeries = createSelector(
  getModoApp,
  modo => modo === MODO_APP_SERIES
);

export const getIsAxis = view(isAxisLens);

export const erroInicializacao = (state: State): ?string =>
  state.erroInicializacao;

export const isSeletorAberto = curry((id: string, state: State): boolean =>
  view(seletoresAbertosLens(id), state)
);

export const isFechamentoDeMesSelecionado = (state: State): boolean => {
  return state.isFechamentoDeMes;
};

export const getTipoDataBaseSelecionada = (state: State): TipoDataBase =>
  state.isFechamentoDeMes
    ? TIPO_DATA_BASE_FECHAMENTO
    : TIPO_DATA_BASE_AUTOMATICA;

export const getMedidasSelecionadasDesabilitada = (state: State): boolean =>
  state.medidasSelecionadasDesabilitada;
